import { css } from '@emotion/core';

import {
  SPACE_COZY,
  flexDirectionColumn,
  flex,
  alignItemsStart,
  SPACE_COMFORTABLE,
  SPACE_RELAXED,
} from '@/styles';

import { generalBarStyles } from '../slo-group/styles';

export const rootMini = css`
  ${flex};
  ${alignItemsStart};
  ${flexDirectionColumn};
`;

export const panelMini = css`
  padding: ${SPACE_COZY}px;
  ${flex};
  ${alignItemsStart};
  ${flexDirectionColumn};
  gap: 12px;
  cursor: pointer;
  box-sizing: border-box;
`;

export const errorMini = css`
  ${flex};
  ${flexDirectionColumn};
  height: 100%;
  width: 100%;
  justify-content: center;
  box-sizing: border-box;
`;

// TODO: search 'badgeStyles' and move it to shared styles
export const badgeStyles = css`
  font-size: 11px;
  font-weight: 600;
`;

// TODO: search 'generalBarStyles' and move it to shared styles
export const cohortBlockStyles = css`
  ${generalBarStyles};
  padding: 8px 0;
  min-width: 110px;
  box-sizing: border-box;
`;

export const cohortBadgeStyles = css`
  div,
  span {
    font-size: 11px;
    font-weight: 400;
  }
`;

export const rootLarge = css`
  min-height: 0;
`;

export const errorLarge = css`
  ${flex};
  ${flexDirectionColumn};
  width: 100%;
  justify-content: center;
  height: auto;
  box-sizing: border-box;
  padding: ${SPACE_COMFORTABLE}px !important;
`;

export const panelLarge = css`
  ${flex};
  ${alignItemsStart};
  cursor: pointer;
  box-sizing: border-box;
  padding: ${SPACE_COMFORTABLE}px !important;
  gap: ${SPACE_RELAXED}px;
  & > div:last-of-type {
    margin-left: auto;
  }
`;
